import React, {PropTypes} from 'react';
import assign from 'object.assign';
import PureComponent from 'components/PureComponent';
import setViewport from 'components/setViewport';
import checkMobile from 'utils/checkMobile';

class Drawer extends PureComponent {

	static propTypes = {
		position: PropTypes.string.isRequired,
		isOpen: PropTypes.bool.isRequired,
		size: PropTypes.string.isRequired,
		onClose: PropTypes.func
	};

	static contextTypes = {
		deviceType: PropTypes.string
	};

	static defaultProps = {
		isOpen: false,
		position: 'left',
		isBlue: false
	};

	render() {
		require('./Drawer.styl');
		const { deviceType } = this.context;
		const isMobile = checkMobile(deviceType, this.props.viewport);
		const {position, size, isOpen} = this.props;
		const style = assign(this.props.style || {}, {
			width: size,
			[position]: isOpen ? 0 : `-${size}`
		}, isMobile ? {height: this.props.viewport.height} : {});

		return (
			<div className={`Drawer`} style={style}>
				<a className={`Drawer__close${this.props.isBlue ? '--blue' : ''}`} onClick={this.props.onClose} />
				{this.props.children}
			</div>
		);
	}

}

export default setViewport(Drawer);



// WEBPACK FOOTER //
// ./src/components/Drawer/Drawer.js